module.exports = __webpack_public_path__ + "img/logo-leads.c37394c3.svg";